import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AddProductAdmin from './Admin/AddProductAdmin';
import EditProductAdmin from './Admin/EditProductAdmin';
import ManageProducts from './Admin/ManageProducts';
import ManageBrands from './Admin/ManageBrands';
import ManageCategories from './Admin/ManageCategories';
import ManageUsers from './Admin/ManageUsers';
import ManageHero from './Admin/ManageHero';
import AppearanceAdmin from './Admin/AppearanceAdmin';
import Orders from './Admin/Orders';
import OrderDetailsFinal from './Admin/OrderDetailsFinal';
import OrderDetails from './Admin/OrderDetails';
import ShippingManagement from './Admin/ShippingManagement';
import DiscountManagement from './Admin/DiscountManagement';
import AuditLogs from './Admin/AuditLogs';
import AdminLogin from './Admin/AdminLogin';
import Home from './Pages/Home';
import Shop from './Pages/Shop';
import ProductDetails from './Pages/ProductDetails';
import Checkout from './Pages/Checkout';
import Wishlist from './Pages/Wishlist';
import NotFound from './Pages/NotFound';
import ProtectedRoute from './Components/ProtectedRoute';
import RequirePermission from './Components/RequirePermission';
import AdminDashboardRedirect from './Components/AdminDashboardRedirect';
import PublicLayout from './Layouts/PublicLayout';
import AdminLayout from './Layouts/AdminLayout';
import { About, PrivacyPolicy, RefundPolicy, ShippingPolicy, Terms, Contact, FAQ } from './Pages/InfoPages';
import OrderConfirmation from './Pages/OrderConfirmation';
import { UserProvider } from './Context/UserContext';
import { CartProvider } from './Context/CartContext';
import { LanguageProvider } from './Context/LanguageContext';
import { WishlistProvider } from './Context/WishlistContext';
import CartDrawer from './Components/CartDrawer';
import ScrollToTop from './Components/ScrollToTop';
import { PERMISSIONS } from './Utils/permissions';

function App() {
  // Removed loading state and loading screen for faster initial load


  return (
    <UserProvider>
      <CartProvider>
        <WishlistProvider>
        <LanguageProvider>
          <Router>
            <ScrollToTop />
            <div className="App">
              <CartDrawer />
            <Routes>
            {/* Public Routes with Header & Footer */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:categorySlug" element={<Shop />} />
              <Route path="/products/:categoryName/:productSlug" element={<ProductDetails />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* Order Confirmation Route - Standalone Page */}
            <Route path="/order-confirmation" element={<OrderConfirmation />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<AdminDashboardRedirect />} />
              <Route path="products" element={<RequirePermission permission={PERMISSIONS.PRODUCTS_MANAGE}><ManageProducts /></RequirePermission>} />
              <Route path="add-product" element={<RequirePermission permission={PERMISSIONS.PRODUCTS_MANAGE}><AddProductAdmin /></RequirePermission>} />
              <Route path="edit-product/:productId" element={<RequirePermission permission={PERMISSIONS.PRODUCTS_MANAGE}><EditProductAdmin /></RequirePermission>} />
              <Route path="appearance" element={<RequirePermission permission={PERMISSIONS.APPEARANCE_MANAGE}><AppearanceAdmin /></RequirePermission>} />
              <Route path="manage-categories" element={<RequirePermission permission={PERMISSIONS.CATEGORIES_MANAGE}><ManageCategories /></RequirePermission>} />
              <Route path="users" element={<RequirePermission permission={PERMISSIONS.USERS_MANAGE}><ManageUsers /></RequirePermission>} />
              <Route path="manage-brands" element={<RequirePermission permission={PERMISSIONS.BRANDS_MANAGE}><ManageBrands /></RequirePermission>} />
              <Route path="manage-hero" element={<RequirePermission permission={PERMISSIONS.HERO_MANAGE}><ManageHero /></RequirePermission>} />
              <Route path="orders" element={<RequirePermission permission={PERMISSIONS.ORDERS_VIEW}><Orders /></RequirePermission>} />
              <Route path="delivery" element={<RequirePermission permission={PERMISSIONS.DELIVERY_VIEW}><Orders /></RequirePermission>} />
              <Route path="orders/:orderId" element={<RequirePermission anyOf={[PERMISSIONS.ORDERS_VIEW, PERMISSIONS.DELIVERY_VIEW]}><OrderDetailsFinal /></RequirePermission>} />
              <Route path="orders/:orderId/details" element={<RequirePermission anyOf={[PERMISSIONS.ORDERS_VIEW, PERMISSIONS.DELIVERY_VIEW]}><OrderDetails /></RequirePermission>} />
              <Route path="shipping" element={<RequirePermission permission={PERMISSIONS.SHIPPING_RATES_MANAGE}><ShippingManagement /></RequirePermission>} />
              <Route path="discounts" element={<RequirePermission permission={PERMISSIONS.DISCOUNTS_MANAGE}><DiscountManagement /></RequirePermission>} />
              <Route path="audit-logs" element={<RequirePermission permission={PERMISSIONS.AUDIT_LOGS_VIEW}><AuditLogs /></RequirePermission>} />
              <Route path="pages" element={<RequirePermission permission={PERMISSIONS.PAGES_MANAGE}><div style={{padding: '20px'}}>Blog Posts (Coming Soon)</div></RequirePermission>} />
            </Route>
            </Routes>
          </div>
        </Router>
        </LanguageProvider>
        </WishlistProvider>
      </CartProvider>
    </UserProvider>
  );
}export default App;
